export const colors = {
  primary: {
    text: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#0A7FE4',
    },
    bg: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#D8EBFF',
    },
    border: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#479EF8',
    },
    ic: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#0A7FE4',
    },
  },
  'secondary-1': {
    text: {
      regular: '#1AAAAD',
      strong: '#076568',
      weak: '#71D7D9',
    },
    bg: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#E0FBFD',
    },
    border: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9',
    },
    ic: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9',
    },
  },
  'secondary-2': {
    text: {
      regular: '#DD2457',
      strong: '#921034',
      weak: '#FF95B3',
    },
    bg: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3',
    },
    border: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3',
    },
    ic: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3',
    },
  },
  'secondary-3': {
    bg: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD',
    },
    border: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD',
    },
    ic: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD',
    },
  },

  neutral: {
    text: {
      regular: '#647180',
      strong: '#373E45',
      weak: '#B6C5D5',
      inverted: '#FFFFFF',
    },
    bg: {
      regular: '#F0F5FB',
      strong: '#EAF1F8',
      stronger: '#B6C5D5',
      weak: '#FFFFFF',
      inverted: '#373E45',
    },
    border: {
      regular: '#B6C5D5',
      strong: '#647180',
      weak: '#DEE8F3',
    },
    ic: {
      regular: '#647180',
      strong: '#373E45',
      weak: '#B6C5D5',
      inverted: '#FFFFFF',
    },
  },
  danger: {
    text: {
      regular: '#DD2457',
      strong: '#921034',
      weak: '#FF95B3',
    },
    bg: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FFF0F4',
    },
    border: {
      regular: '#DD2457',
      strong: '#B11E47',
    },
    ic: {
      regular: '#DD2457',
    },
  },
  warning: {
    text: {
      regular: '#623311',
    },
    bg: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF4CD',
    },
    border: {
      regular: '#FECF2F',
      strong: '#FFA53F',
    },
    ic: {
      regular: '#FFA53F',
    },
  },
  info: {
    text: {
      regular: '#023F80',
    },
    bg: {
      regular: '#479EF8',
      strong: '#023F80',
      weak: '#D8EBFF',
    },
    border: {
      regular: '#479EF8',
      strong: '#023F80',
    },
    ic: {
      regular: '#479EF8',
    },
  },
  success: {
    text: {
      regular: '#035456',
    },
    bg: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#E0FBFD',
    },
    border: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9',
    },
    ic: {
      regular: '#1AAAAD',
    },
  },
};
